export default __webpack_public_path__ + "static/media/history-hex.c12023f8.png";